import styled from 'styled-components'

export const AdsHighlight = styled.div`
  display: grid;
  gap: 1.2rem;
  background-color: ${({ theme }) => theme.colors.hopbush};
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23005F89' stroke-width='4' stroke-dasharray='8%2c12' stroke-linecap='square'/%3e%3c/svg%3e");
  padding: 2.8rem 3rem;

  ${({ theme }) => theme.breakpoints.down('desktop')} {
    padding: 2.4rem 2rem;
  }
`

export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin: 0 0 0.5rem 0;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.firaSansLg};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 1.2rem;
`
